<template>
    <Link :href="route('catalog',{
        category_title:'plitka',
        colors: JSON.stringify([id])
    })" class="relative" :aria-label="title">
        <div class="w-12 h-12 rounded-lg shadow-sm border-2"
             :style="{'background-color': hex}"
             @mouseenter="showTooltip"
             @mouseleave="hideTooltip"></div>
        <div v-if="tooltipVisible" role="tooltip"
             class="max-md:hidden absolute -top-12 left-0 mt-2 z-10 inline-block px-3 py-2 text-sm font-medium text-nowrap text-black transition-opacity duration-300 bg-baseColor rounded-lg shadow-xs">
            {{ title }}
            <div class="tooltip-arrow" data-popper-arrow></div>
        </div>
    </Link>
</template>

<script>
import {Link} from "@inertiajs/vue3";

export default {
    name: "ColorChoiceItem",
    components: {Link},
    props: {
        id: {
            required: true,
        },
        hex: {
            required: true,
            type: String,
        },
        title: {
            required: true,
            type: String,
        }
    },
    data() {
        return {
            tooltipVisible: false,
        }
    },
    mounted() {

    },
    methods: {
        showTooltip() {
            this.tooltipVisible = true;
        },
        hideTooltip() {
            this.tooltipVisible = false;
        },
    }
};
</script>

<style scoped>
</style>
